// История рейса: чистые помощники экрана — время, повторы, фильтры, группировка по дням.

function pad(n) {
  return String(n).padStart(2, '0')
}

function toDate(value) {
  if (!value) return null
  const d = new Date(value)
  return Number.isNaN(d.getTime()) ? null : d
}

// Время — по часам компьютера пользователя (офис — Ульяновск).
export function formatTime(value) {
  const d = toDate(value)
  return d ? pad(d.getHours()) + ':' + pad(d.getMinutes()) : ''
}

export function dayKey(value) {
  const d = toDate(value)
  return d ? d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) : ''
}

export function dayTitle(value, now = new Date()) {
  const d = toDate(value)
  if (!d) return ''
  const key = dayKey(d)
  if (key === dayKey(now)) return 'Сегодня'
  const yesterday = new Date(now.getTime() - 24 * 3600 * 1000)
  if (key === dayKey(yesterday)) return 'Вчера'
  return pad(d.getDate()) + '.' + pad(d.getMonth() + 1) + '.' + d.getFullYear()
}

export function repeatText(event) {
  if (!event || !event.count || event.count < 2) return ''
  const since = event.first_at ? ' с ' + formatTime(event.first_at) : ''
  return 'повторялось ' + event.count + ' раз' + since
}

export const FILTERS = [
  { key: 'all', title: 'Всё' },
  { key: 'status', title: 'Статусы' },
  { key: 'action', title: 'Действия' },
  { key: 'tms', title: 'TMS' },
  { key: 'sync', title: 'Сверка' },
  { key: 'comment', title: 'Комментарии' },
]

export function filterEvents(events = [], key = 'all') {
  if (!key || key === 'all') return events
  return events.filter((e) => e.category === key)
}

export function countBy(events = []) {
  const out = { all: 0 }
  for (const e of events) {
    out.all += 1
    out[e.category] = (out[e.category] || 0) + 1
  }
  return out
}

export function groupByDay(events = [], now = new Date()) {
  const groups = []
  for (const e of events) {
    const key = dayKey(e.at)
    let group = groups[groups.length - 1]
    if (!group || group.key !== key) {
      group = { key, title: dayTitle(e.at, now), items: [] }
      groups.push(group)
    }
    group.items.push(e)
  }
  return groups
}
